import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const saveTestCaseSettings = async ({ testCaseId, payload }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=savetcsettings&companyid=${user.companyid}&tcid=${testCaseId}`,
      payload,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });

  return response;
};

const useSaveTestCaseSettingsQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveTestCaseSettings,
    onSuccess: () => {
      queryClient.invalidateQueries(["testCaseResults"]);
    },
    onError: (error) => {
      console.log("Error uploading file", error.message);
    },
  });
};

export default useSaveTestCaseSettingsQuery;
